export default "__VITE_ASSET__hXoFWuTh__"